export default __webpack_public_path__ + "static/media/womangoat.7cc5846d.png";